import { ERole } from '@helipagos/auth';

export const baseRouteNavigatorsConstant = [
  {
    nombre: 'Movimientos',
    url: '/home',
    icon_name: 'lucideArrowRightLeft',
    state: false,
    roles: [ERole.ROLE_ADMIN],
  },
  {
    nombre: 'Clientes',
    url: '/clients',
    icon_name: 'lucideUser',
    state: false,
    roles: [ERole.ROLE_ADMIN],
  },
  {
    nombre: 'Checkout V2',
    url: '/checkout',
    icon_name: 'lucideUser',
    state: false,
    roles: [ERole.ROLE_ADMIN],
  },
  // Oculto del sidebar hasta liberar Feriados en producción. La ruta /configuration
  // y la feature siguen existiendo; solo se quita el acceso visible. Reactivar
  // descomentando este item.
  // {
  //   nombre: 'Configuración',
  //   url: '/configuration',
  //   icon_name: 'lucideSettings',
  //   state: false,
  //   roles: [ERole.ROLE_ADMIN],
  // },
];
